<template>
  <div class="docs-menu-container">
    <el-menu
      :default-active="currentId"
      active-text-color="#36f"
      @select="handleSelect"
      @open="handleOpen"
      @close="handleClose"
    >
      <el-submenu :index="'' + item.id" v-for="item in menuList" :key="item.id">
        <template slot="title">
          <span style="color: #010007cc; font-family: 'EnglishFontT3'">{{
            item.name
          }}</span>
          <img
            :src="openList.includes(String(item.id)) ? upIcon : downIcon"
            alt="icon"
            style="width: 14px; height: 14px; transition: transform 0.3s"
          />
        </template>

        <el-submenu
          :index="'' + submenu.id"
          v-for="submenu in item.childrenList"
          :key="submenu.id"
        >
          <template slot="title">{{ submenu.name }}</template>
          <el-menu-item
            :index="'' + subblog.id"
            v-for="subblog in submenu.articleList"
            :key="subblog.id"
            ><div class="blog_name" :title="subblog.title">
              <!-- 三级选项有icon -->
              <img :src="getDocumentIcon(subblog.id)" alt="" />
              <span class="overflow-hidden">{{ subblog.title }}</span>
            </div></el-menu-item
          >
        </el-submenu>

        <el-menu-item
          :index="'' + blog.id"
          v-for="blog in item.articleList"
          :key="blog.id"
        >
          <div class="blog_name" :title="blog.title">
            <!-- 没有子菜单的才有icon -->
            <img
              v-if="!blog.articleList"
              :src="getDocumentIcon(blog.id)"
              alt=""
            />
            <span class="overflow-hidden">{{ blog.title }}</span>
          </div>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  data() {
    return {
      documentIcon: require("@/assets/icons/document.svg"),
      documentActiveIcon: require("@/assets/icons/document_active.svg"),
      upIcon: require("@/assets/icons/menu_up.svg"),
      downIcon: require("@/assets/icons/menu_down.svg"),
      openList: [],
    }
  },
  computed: {
    ...mapState(["currentColumnId"]),
  },
  props: {
    currentId: {
      default: "",
      type: String,
    },
    menuList: {
      default: () => [],
      type: Array,
      require: true,
    },
  },
  mounted() {
    this.openList = [this.currentColumnId]
  },
  methods: {
    ...mapMutations(["SET_CURRENTCOLUMN"]),
    handleSelect(id, v) {
      this.SET_CURRENTCOLUMN(v[0])
      if (this.currentId !== id) {
        this.$emit("changeBlog", id)
      }
    },
    handleOpen(id) {
      if (!this.openList.includes(id)) this.openList.push(id)
    },
    handleClose(id) {
      this.openList = this.openList.filter((item) => item !== id)
    },
    getDocumentIcon(id) {
      return +this.currentId === id
        ? this.documentActiveIcon
        : this.documentIcon
    },
  },
}
</script>

<style lang="scss">
.docs-menu-container {
  background: #ffffff;
  user-select: none;
  .el-menu {
    border-right: none;
    background: #ffffff;
  }
  .el-menu-item,
  .el-submenu__title {
    padding-left: 10px !important;
    height: 46px !important;
    line-height: 46px !important;
    font-size: 17px;
  }
  .el-menu-item {
    padding-left: 26px !important;
    border-radius: 8px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
    &:hover {
      color: #36f;
    }
  }
  .el-menu-item.is-active {
    color: #ffffff !important;
    background-color: #0057ff;
  }

  .el-submenu,
  .el-submenu__title {
    color: #576b95;
    font-weight: 500;
  }
  .el-menu-item:focus,
  .el-menu-item:hover,
  .el-submenu__title:hover {
    border-radius: 8px;
    color: #36f;
    background: #0057ff1a;
  }
  .el-menu-item.is-active:hover {
    background-color: #0057ff;
  }
}
</style>
<style lang="scss" scoped>
.overflow-hidden {
  overflow: hidden; /* 超出部分隐藏 */
  white-space: nowrap; /* 文本不换行 */
  text-overflow: ellipsis;
}
.docs-menu-container {
  .blog_name {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    // line-height: 46px;
    overflow: hidden; /* 超出部分隐藏 */
    white-space: nowrap; /* 文本不换行 */
    text-overflow: ellipsis;
    font-size: 16px;
    img {
      width: 15px;
      height: 15px;
    }
  }
  ::v-deep(.el-submenu__title) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-submenu__icon-arrow {
      display: none !important;
    }
  }
}
</style>
